// extracted by mini-css-extract-plugin
export default {"drawer":"ErrorBottomDrawer_drawer__7u++3"};